import { api } from "@/frontend/services/api";
import type {
  TournamentStandingResponseDTO,
  TournamentStandingGroupedDTO,
  TournamentStandingsPaginatedResponseDTO,
  AssignTournamentStandingGroupRequestDTO,
  ApiResponse,
  PaginationRequestDTO,
  SyncTournamentStandingGroupsRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/tournament-standings/private";

export const tournamentStandingService = {
  getPaginate: (params?: PaginationRequestDTO) => {
    return api.getWithParams<ApiResponse<TournamentStandingsPaginatedResponseDTO>>(BASE_URL, params);
  },
  getBySeasonId: (
    seasonId: string,
    params?: { grouped?: boolean }
  ) =>
    api.get<
      ApiResponse<
        | TournamentStandingResponseDTO[]
        | TournamentStandingGroupedDTO[]
      >
    >(`${BASE_URL}/season/${seasonId}`, { params }),
  getByGroupId: (groupId: string) => 
    api.get<ApiResponse<TournamentStandingResponseDTO[]>>(`${BASE_URL}/group/${groupId}`),
  updateFixtureStandings: (
    seasonId: string,
    groupId: string,
    fixtureId: string,
  ) =>
    api.post<ApiResponse<any>>(
      `${BASE_URL}/update-fixture/${seasonId}/${groupId}/${fixtureId}`,
    ),
  assignGroup: (data: AssignTournamentStandingGroupRequestDTO) =>
    api.post<ApiResponse<TournamentStandingResponseDTO>>(`${BASE_URL}/assign-group`, data),
  syncGroups: (data: SyncTournamentStandingGroupsRequestDTO) =>
    api.post<ApiResponse<any>>(`${BASE_URL}/sync-groups`, data),
};
